// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Priorities_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/priorities/remover
 *
 * Deletes a priority by ID.
 */
import { registerContract } from './validate'

export interface Priorities_RemoverInput {
so_priority_id: number
}

registerContract('Priorities_RemoverInput', {
  so_priority_id: { type: 'number',  required: true },
})
